// @core/api/endpoints/form/create_form_field.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFormFieldRequest,
  FormFieldResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Create form field
 * Creates a new field within a form. The field is added to the specified page.
 */
export async function CreateFormField(
  form_id: string,
  data: CreateFormFieldRequest,
  options?: RequestOptions
): Promise<FormFieldResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/fields`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.post<FormFieldResponse>(requestPath, data, requestOptions);
}
